export const LIVE_BANNER_APPEARANCE_STORAGE_KEY = 'live-banner-appearance-tracker';
